import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/forms/FormCreator";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import { ViewIndividualMemberConfig, ViewIndividualMemberData } from "./data/ViewIndividualMember.Data";
import { viewIndividualMemberListFormDropdownConfigs } from "./utils/setDropdownFields";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { useDeleteViewIndivudualMemberMutation, useLazyGetAllDropDownsForTaskListQuery } from "../../app/services/MembershipTaskList/MembershipTaskListServiceApi";
import { useGetViewIndividualMemberListMutation } from "../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi";
import { paginationObj } from "../../utils/Constants";
import Buttons from "../../components/ui/button/Buttons";
import { encryptAESID } from "../../utils/Encryption";
import { useNavigate } from "react-router-dom";
import SwalAlert from "../../services/swalService/SwalService";
import "./ViewIndividualMemberForm.scss"
import { getAuditContext } from "../../lib/authenticationLibrary";

const ViewIndividualMemberForm = () => {
    const viewIndividualMemberTableRef = useRef();
    const navigate = useNavigate();
    const molGridRef = useRef();
    const { confirm, success, error } = SwalAlert();
    const audit = getAuditContext();
    /* State */
    const [viewIndividualMemberTable, setviewIndividualMemberTable] = useState(ViewIndividualMemberData);
    const [dataSource, setDataSource] = useState();
    const [pagination, setPagination] = useState({
        ...paginationObj,
        Name: null,
        EmailAddress: null,
        MembershipTypeId: null,
        SubscriptionStatusId: null,
    });

    // API Calls
    const [getTaskListDropDown, { isLoading: taskListDropDownIsLoading, isSuccess: taskListDropDownIsSuccess, data: taskListDropDownData }] = useLazyGetAllDropDownsForTaskListQuery();
    const [getViewIndividualMemberList, { isLoading: isMemberListLoading, isSuccess: isMemberListSuccess, data: memberListData }] = useGetViewIndividualMemberListMutation();

    const [deleteViewIndivudualMember, { isSuccess: isSuccessdeleteEmailTemplate, data: deleteEmailTemplateResponse }] = useDeleteViewIndivudualMemberMutation();


    // useEffects
    useEffect(() => {
        if (!isMemberListLoading && memberListData && isMemberListSuccess) {
            setDataSource(memberListData.itemList)
            setPagination(prev => {
                return { ...prev, totalCount: memberListData.totalCount }
            });
        }
    }, [isMemberListLoading, memberListData, isMemberListSuccess]);

    useEffect(() => {
        if (!taskListDropDownIsLoading && taskListDropDownIsSuccess && taskListDropDownData) {
            // Updates dropdown fields in the form based on the fetched data
            setAllDropDownFieldsBatch(ViewIndividualMemberData, viewIndividualMemberListFormDropdownConfigs, taskListDropDownData);

            const changesOpttionOrder = (form) => {
                form.section?.forEach(section => {
                    section.fields?.forEach(field => {
                      if (field.id === "membershipTypeName") {
                        const options = field.fieldSetting?.options;
                        if (options) {
                          const nonMember = options.find(o =>
                            o.value === 6 || o.label === "Non Member"
                          );
                          if (nonMember) {
                            field.fieldSetting.options = [
                              ...options.filter(o => o !== nonMember), nonMember
                            ];
                          }
                        }
                      }
                    });
                  });
              };

              changesOpttionOrder(ViewIndividualMemberData);
              setviewIndividualMemberTable(prev => ({ ...prev }))

        }
    }, [taskListDropDownIsLoading, taskListDropDownIsSuccess, taskListDropDownData]);

    useEffect(() => {
        getTaskListDropDown();
        getMemberList(pagination)
    }, []);

    useEffect(() => {
        if (isSuccessdeleteEmailTemplate && deleteEmailTemplateResponse) {
            if (deleteEmailTemplateResponse.hasError === false) {
                success("Individual Member Deleted Successfully");
                getViewIndividualMemberList(pagination);
            }
            else {
                error(deleteEmailTemplateResponse.errorMessage)
            }
        }
    }, [isSuccessdeleteEmailTemplate, deleteEmailTemplateResponse]);


    // Functions
    const getMemberList = (data) => {
        getViewIndividualMemberList(data);
    }

    const handlePageChange = (page) => {
        const { pageNumber, pageSize } = page;
        getMemberList({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
    };

    const searchClick = () => {
        let formData = viewIndividualMemberTableRef?.current?.getFormData();
        console.log(formData)
        let request = {
            ...paginationObj,
            Name: formData?.name || null,
            EmailAddress: formData?.emailAddress || null,
            MembershipTypeId: formData?.membershipTypeName?.value || null,
            SubscriptionStatusId: formData?.applicationStatus?.value || null,
        }
        setPagination(prev => { return { ...prev, ...request } });
        getMemberList(request);
    };

    const handleEditClick = (rowData, index) => {
        const { ipasMemberId } = rowData;
        if (ipasMemberId)
            window.open(`/editViewIndividualMember/${encryptAESID(ipasMemberId)}`, '_self')
    };

    const handleDeleteclick = (data) => {
        confirm('Delete?', 'Are you sure you want to Delete?', 'Delete', 'Cancel').then((confirmed) => {
            if (confirmed) {
                debugger
                console.log(data, "ipasmemberId");

                const request = {
                    id: data.ipasMemberId,
                    deletedBy: audit.adminUserId,
                    appId: audit.appId
                }
                deleteViewIndivudualMember(request);
            }
        });
    }

    const handleRedirect = () => {
        // navigate('/HonoraryMember')
        window.open(('/HonoraryMember'), '_self');
    }

    const actionHandler = {
        EDIT: handleEditClick,
        DELETE: handleDeleteclick
    }

    const handleClearClick = () => {
        const formData = { ...viewIndividualMemberTable };
        formData.initialState = {
            name: "",
            emailAddress: "",
            membershipTypeName: null,
            applicationStatus: null
        }
        let request = {
            ...paginationObj,
            Name: null,
            EmailAddress: null,
            MembershipTypeId: null,
            SubscriptionStatusId: null,
        }
        setPagination(prev => { return { ...prev, ...request } });
        getMemberList(request);
        setviewIndividualMemberTable(formData);
    }

    return (
        <div>
            <div className="membership-application">
                <div className="form-card ">
                    {taskListDropDownData && taskListDropDownIsSuccess &&
                        <>
                            <FormCreator
                                config={viewIndividualMemberTable}
                                ref={viewIndividualMemberTableRef}
                                key={false}
                            />
                            <div className="mt-2 col-lg-12 btn-sec">
                                <Buttons
                                    onClick={handleClearClick}
                                    buttonText={"Clear"}
                                    buttonTypeClassName="back-btn btn mt-auto mr-4 text-light"
                                    isLoading={false}
                                />
                                <Buttons
                                    onClick={searchClick}
                                    buttonText={"Search"}
                                    buttonTypeClassName="theme-btn btn mt-auto"
                                    isLoading={isMemberListLoading}
                                />
                            </div>
                            <div className="d-flex justify-content-between mt-3 mb-0">
                                <h5 className="align-self-end mb-0">Total Count: {memberListData?.totalCount || 0}</h5>
                                <Buttons
                                    onClick={handleRedirect}
                                    buttonText={"Create New Honorary Member"}
                                    buttonTypeClassName="outline-theme-btn btn mt-auto"
                                    isLoading={false}
                                />
                            </div>
                        </>
                    }
                    <div className="table-100 mt-2">
                        <FinalMolGrid
                            ref={molGridRef}
                            configuration={ViewIndividualMemberConfig}
                            dataSource={dataSource}
                            isLoading={isMemberListLoading}
                            allowPagination={true}
                            pagination={pagination}
                            onActionChange={actionHandler}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ViewIndividualMemberForm;
